import Select from 'react-select'
import styled from '@emotion/styled'
import './selectStyle.css'

export type SelectProps = {
  placeholder: string
  value: { value: any, label: string } | undefined
  options: any[] | undefined
  onChange?: (selectedValue: any) => void
}

const Content = styled.div`
  font-size: 0.75rem;
  min-width: 400px;
  padding-left: 1rem;
  .medSelect__control--is-focused{
    border: 1px solid black;
  },
  .medSelect__value-container{
    height: 35px;
  },
`

export function SelectSearch({ placeholder, options, value, onChange }: SelectProps) {
  return <Content>
    <Select
      classNamePrefix='medSelect'
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
  </Content>
}